import {useState} from 'react';
import {NavLink} from 'react-router-dom';
import {PersonBoundingBox, Floppy} from 'react-bootstrap-icons';

function NavBar() {
  return (
    <nav>
      <div className='sidebar'>
        <div className='sidebar_items'>
          <div className='sidebar_logo'>
            <img className='logo_image' src='./amsLogo.svg' alt='' />
          </div>

          <NavLink
            className='icon-link sidebar_item'
            end
            to='/PersonaDiscovery'>
            <PersonBoundingBox />
            Persona Discovery
          </NavLink>

          <NavLink
            className='icon-link sidebar_item'
            end
            to='/SellMessagingCreator'>
            <Floppy />
            Sell Messaging Creator
          </NavLink>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
